<template>
  <div class="dibu">
    <div class="nei">
      <div class="ll">
        <img src="../assets/shiye.png" alt="" />
      </div>
      <div class="left">
        <div class="lianjie">
          <span>友情链接:</span>
          <div class="xuan">
            <el-select
              v-model="value"
              @change="xuanze()"
              placeholder="请选择网站"
            >
              <el-option
                v-for="item in youq"
                :key="item.id"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="shang">
          <span @click="guan(1)">关于平台</span>
          <span @click="guan(2)">法律声明</span>
          <span @click="guan(3)">帮助中心</span>
          <span @click="guan(4)">联系方式</span>
        </div>
        <div class="xia">
          <span>粤ICP备2023043568号</span>
          <span>|</span>
          <span>深圳市科技创新局</span>
          <span>|</span>
          <span>深圳市新质生产力科技促进中心</span>
        </div>
      </div>
      <div class="rightg">
        <img src="../assets/diz2.png" alt="" />
        <!-- <img src="../assets/diy.png" alt="" /> -->
      </div>
    </div>
  </div>
</template>
<script>
import { news } from "@/api/index";
export default {
  name: "Footh",
  data() {
    return {
      youq: {},
      value: "请选择网站",
      jie: "",
    };
  },
  components: {},
  mounted() {
    this.nei();
  },
  methods: {
    guan(id) {
      if (id == 1) {
        id = "关于平台";
      }
      if (id == 2) {
        id = "法律声明";
      }
      if (id == 3) {
        id = "帮助中心";
      }
      if (id == 4) {
        id = "联系方式";
      }
      sessionStorage.setItem("insuranceCode", JSON.stringify(12));
      document.documentElement.scrollTop = 0;
      this.$router.push(`/guanyu?id=${id}`);
    },
    nei() {
      let datasss = {
        params: {
          pageNo: 1,
          pageSize: 10,
          status: 2,
        },
      };
      news(datasss).then((res) => {
        if (res.status == 200) {
          this.youq = res.data.data.list;
        }
      });
    },
    xuanze() {
      for (let i = 0; i < this.youq.length; i++) {
        if (this.youq[i].title == this.value) {
          this.jie = this.youq[i].linkAddress;
        }
      }
      this.$confirm("您访问的链接即将离开当前页面，是否继续？", "友情提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning", // 可选，用于显示警告类型的对话框
      })
        .then(() => {
          // 用户点击了“确定”按钮
          window.open(this.jie, "_blank");
        })
        .catch(() => {
          // 用户点击了“取消”按钮
          // 这里可以处理取消操作，或者什么也不做
          // console.log("用户取消了操作");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.dibu {
  min-width: 1200px;
  height: 200px;
  // background-color: rgba(153, 153, 153, 0.3);
  // background-image: url(../assets/dibu.png);
  background: #203378;
}
::v-deep .lianjie {
  margin-left: -80px;
  margin-top: 44px;
  display: flex;
  .xuan {
    margin-left: 20px;
  }
  .el-input__inner {
    width: 300px;
    height: 25px;
    background: #ffffff;
    border-radius: 5px;
  }
  .el-input--small .el-input__icon {
    line-height: 25px;
  }
}
.nei {
  position: relative;
  display: flex;
  width: 1200px;
  margin: 0 auto;
  height: 80px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  .ll {
    height: 80px;
    img {
      padding-top: 83px;
      margin-right: 20px;
      width: 65px;
      height: 65px;
    }
  }
  .left {
    height: 80px;
    .shang {
      padding-top: 17px;
      margin-bottom: 17px;
      span {
        margin-right: 36px;
        cursor: pointer;
      }
    }
    .xia {
      span {
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }
  .rightg {
    position: absolute;
    top: 36px;
    right: 0;
    img {
      margin-top: 8px;
      margin-left: 29px;
    }
  }
}
</style>
